import { render, staticRenderFns } from "./EstimateTax.vue?vue&type=template&id=9584db48&"
import script from "./EstimateTax.vue?vue&type=script&lang=js&"
export * from "./EstimateTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9584db48')) {
      api.createRecord('9584db48', component.options)
    } else {
      api.reload('9584db48', component.options)
    }
    module.hot.accept("./EstimateTax.vue?vue&type=template&id=9584db48&", function () {
      api.rerender('9584db48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/EstimateTax.vue"
export default component.exports